import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { findOuById, getParents, useOrganisationHierarchy } from '@app/sdk';
import { ProductOrMerchant } from './ProductOrMerchant';

export function OuSelector({
  item,
  selectedOuId,
  setSelectedOuId,
}: {
  item: ProductOrMerchant | undefined;
  selectedOuId: string;
  setSelectedOuId: Dispatch<SetStateAction<string>>;
}) {
  const { data: tenantHierarchy } = useOrganisationHierarchy();

  const parents = useMemo(() => {
    if (tenantHierarchy && item) {
      const parentOus = findOuById(tenantHierarchy.organisationUnit, item?.organisationUnitId);
      const parents = getParents(tenantHierarchy, parentOus);
      return [...parents, parentOus];
    }
    return [];
  }, [tenantHierarchy, item]);

  return (
    <div className="field">
      <div className="ui labeled input">
        <div className="ui label">Organisation Unit</div>
        <div className="ui input">
          <select
            key={item?.productId || item?.merchantId}
            defaultValue={item?.organisationUnitId}
            value={selectedOuId}
            onChange={(e) => setSelectedOuId(e.target.value)}>
            {parents.map((parent) => {
              return (
                <option key={parent.id} value={parent.id}>
                  {parent.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
}
